import { lazy } from 'react';
import { retry } from '@/utils/helpers/common';

// Partner pages
export const PartnerListPage = lazy(
  () =>
    retry(() => import('@pages/administrative/portafolio/partners/list')) as Promise<
      typeof import('@pages/administrative/portafolio/partners/list')
    >
);

export const PartnerCreatePage = lazy(
  () =>
    retry(() => import('@pages/administrative/portafolio/partners/create')) as Promise<
      typeof import('@pages/administrative/portafolio/partners/create')
    >
);

export const PartnerEditPage = lazy(
  () =>
    retry(() => import('@pages/administrative/portafolio/partners/edit')) as Promise<
      typeof import('@pages/administrative/portafolio/partners/edit')
    >
);

export const PartnerTabsPage = lazy(
  () =>
    retry(() => import('@pages/administrative/portafolio/partners/tabs')) as Promise<
      typeof import('@pages/administrative/portafolio/partners/tabs')
    >
);

export const PartnerContactCreatePage = lazy(
  () =>
    retry(() => import('@pages/administrative/portafolio/partners/contact-create')) as Promise<
      typeof import('@pages/administrative/portafolio/partners/contact-create')
    >
);

export const PartnerContactEditPage = lazy(
  () =>
    retry(() => import('@pages/administrative/portafolio/partners/contact-edit')) as Promise<
      typeof import('@pages/administrative/portafolio/partners/contact-edit')
    >
);

export const PartnerInformationEditPage = lazy(
  () =>
    retry(() => import('@pages/administrative/portafolio/partners/information-edit')) as Promise<
      typeof import('@pages/administrative/portafolio/partners/information-edit')
    >
);

export const PartnerProviderCreatePage = lazy(
  () =>
    retry(() => import('@pages/administrative/portafolio/partners/provider-create')) as Promise<
      typeof import('@pages/administrative/portafolio/partners/provider-create')
    >
);

export const PartnerProviderEditPage = lazy(
  () =>
    retry(() => import('@pages/administrative/portafolio/partners/provider-edit')) as Promise<
      typeof import('@pages/administrative/portafolio/partners/provider-edit')
    >
);

// Product pages
export const ProductListPage = lazy(
  () =>
    retry(() => import('@pages/administrative/portafolio/products/list')) as Promise<
      typeof import('@pages/administrative/portafolio/products/list')
    >
);

export const ProductInformationPage = lazy(
  () =>
    retry(() => import('@pages/administrative/portafolio/products/information')) as Promise<
      typeof import('@pages/administrative/portafolio/products/information')
    >
);

export const ProductSKUsPage = lazy(
  () =>
    retry(() => import('@pages/administrative/portafolio/products/skus')) as Promise<
      typeof import('@pages/administrative/portafolio/products/skus')
    >
);

export const ProductCreatePage = lazy(
  () =>
    retry(() => import('@pages/administrative/portafolio/products/create')) as Promise<
      typeof import('@pages/administrative/portafolio/products/create')
    >
);

export const ProductEditPage = lazy(
  () =>
    retry(() => import('@pages/administrative/portafolio/products/edit')) as Promise<
      typeof import('@pages/administrative/portafolio/products/edit')
    >
);

// SKU pages
export const SkuListPage = lazy(
  () =>
    retry(() => import('@pages/administrative/portafolio/skus/list')) as Promise<
      typeof import('@pages/administrative/portafolio/skus/list')
    >
);

export const SkuCreatePage = lazy(
  () =>
    retry(() => import('@pages/administrative/portafolio/skus/create')) as Promise<
      typeof import('@pages/administrative/portafolio/skus/create')
    >
);

export const SkuEditPage = lazy(
  () =>
    retry(() => import('@pages/administrative/portafolio/skus/edit')) as Promise<
      typeof import('@pages/administrative/portafolio/skus/edit')
    >
);

export const SkuInformationPage = lazy(
  () =>
    retry(() => import('@pages/administrative/portafolio/skus/information')) as Promise<
      typeof import('@pages/administrative/portafolio/skus/information')
    >
);

export const SkuPlansPage = lazy(
  () =>
    retry(() => import('@pages/administrative/portafolio/skus/plans')) as Promise<
      typeof import('@pages/administrative/portafolio/skus/plans')
    >
);

// Plan pages
export const PlanListPage = lazy(
  () =>
    retry(() => import('@pages/administrative/portafolio/plans/list')) as Promise<
      typeof import('@pages/administrative/portafolio/plans/list')
    >
);

export const PlanCreatePage = lazy(
  () =>
    retry(() => import('@pages/administrative/portafolio/plans/create')) as Promise<
      typeof import('@pages/administrative/portafolio/plans/create')
    >
);

export const PlanEditPage = lazy(
  () =>
    retry(() => import('@pages/administrative/portafolio/plans/edit')) as Promise<
      typeof import('@pages/administrative/portafolio/plans/edit')
    >
);

export const PlanInformationPage = lazy(
  () =>
    retry(() => import('@pages/administrative/portafolio/plans/information')) as Promise<
      typeof import('@pages/administrative/portafolio/plans/information')
    >
);

export const PlanSubscriptionPage = lazy(
  () =>
    retry(() => import('@pages/administrative/portafolio/plans/subscription')) as Promise<
      typeof import('@pages/administrative/portafolio/plans/subscription')
    >
);

// Pricebook pages
export const PricebookListPage = lazy(
  () =>
    retry(() => import('@pages/administrative/portafolio/pricebook/list')) as Promise<
      typeof import('@pages/administrative/portafolio/pricebook/list')
    >
);

export const PricebookCreatePage = lazy(
  () =>
    retry(() => import('@pages/administrative/portafolio/pricebook/create')) as Promise<
      typeof import('@pages/administrative/portafolio/pricebook/create')
    >
);

export const PricebookEditPage = lazy(
  () =>
    retry(() => import('@pages/administrative/portafolio/pricebook/edit')) as Promise<
      typeof import('@pages/administrative/portafolio/pricebook/edit')
    >
);
